export const COLORS = {
  COLOR_TOOLTIP_ERROR: '#cf1322',
  COLOR_DANGER: '#FE4D4F',
  PRIMARY: '#2cabe3',
  BD_CHECKED: '#1890ff',
  BG_CHECKED: '#e6f7ff',
  BD_NOT_CHECK: '#faad14',
  BG_NOT_CHECK: '#fffbe6',
  COLOR_SUCCESS: '#4CAF50',
}

export const BREAKPOINT = {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
  XXL: 1400,
}
